import { DateTime } from 'luxon';
import { OrderStatus } from './OrderStatus';
import { Pagination, paginationToParams } from '../Pagination';

export interface OrderFilter {
  id?: string;
  barcode?: string;
  cargoNo?: string;
  customerName?: string;
  customerPhone?: string;
  email?: string;
  productName?: string;
  status?: OrderStatus;
  affiliateCode?: string;
  startAt?: Date;
  endAt?: Date;
  pagination: Pagination;
}

export const orderFilterToParams = (orderFilter: OrderFilter) => ({
  id: orderFilter.id ? Number(orderFilter.id) : undefined,
  barcode: orderFilter.barcode || undefined,
  'cargo-no': orderFilter.cargoNo || undefined,
  'customer-name': orderFilter.customerName || undefined,
  'customer-phone': orderFilter.customerPhone || undefined,
  email: orderFilter.email || undefined,
  'product-name': orderFilter.productName || undefined,
  status: orderFilter.status || undefined,
  'affiliate-code': orderFilter.affiliateCode || undefined,
  'start-at': orderFilter.startAt
    ? DateTime.fromJSDate(orderFilter.startAt).toISO()
    : undefined,
  'end-at': orderFilter.endAt
    ? DateTime.fromJSDate(orderFilter.endAt).toISO()
    : undefined,
  ...paginationToParams(orderFilter.pagination),
});
